import store from '@/store'

export function beginUserUpload() {
  store.commit('app/beginUserUpload')
}

export function trackUserUpload(uploadId: string, total: number) {
  store.commit('app/trackUserUpload', { uploadId, total })
}

export function releaseUserUpload() {
  store.commit('app/finishUserUpload')
}
